import React, { useState, useEffect } from "react";
import AOS from "aos";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Preloader from "../components/sections/Preloader";
import ScrollTop from "../components/sections/ScrollTop";
import { nftCollection } from "../data/nftCollection";
import "../styles/free-mint.css";
import "../styles/benefits.css";

const FreeMint = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });

    // Get end date from environment variable (UTC)
    const endDateString = process.env.REACT_APP_MINT_END_DATE;
    let targetDate;

    if (endDateString) {
      // Parse UTC date string
      targetDate = new Date(endDateString);

      // Validate date
      if (isNaN(targetDate.getTime())) {
        console.error(
          "Invalid REACT_APP_MINT_END_DATE format. Using default (24/12/2025 07:00 UTC)."
        );
        // Default: 24 December 2025, 07:00:00 UTC (2pm VN time)
        targetDate = new Date(Date.UTC(2025, 11, 24, 7, 0, 0));
      }
    } else {
      // Fallback to 24 December 2025, 07:00:00 UTC if env variable is not set (2pm VN time)
      console.warn(
        "REACT_APP_MINT_END_DATE not set. Using default (24/12/2025 07:00 UTC)."
      );
      // Default: 24 December 2025, 07:00:00 UTC (2pm VN time, UTC+7)
      targetDate = new Date(Date.UTC(2025, 11, 24, 7, 0, 0));
    }

    const timer = setInterval(() => {
      // Get current time in UTC
      const now = new Date();
      const nowUTC = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds()
      );

      // Get target time in UTC
      const targetUTC = Date.UTC(
        targetDate.getUTCFullYear(),
        targetDate.getUTCMonth(),
        targetDate.getUTCDate(),
        targetDate.getUTCHours(),
        targetDate.getUTCMinutes(),
        targetDate.getUTCSeconds()
      );

      const distance = targetUTC - nowUTC;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const benefits = [
    {
      id: 1,
      title: "OG Identity & Exclusive Badge",
      description:
        "CVMech holders are recognized as OG members within the CVPad ecosystem and receive an exclusive OG Badge on Discord.",
    },
    {
      id: 2,
      title: "Exclusive Campaigns & Giveaways ($10,000+)",
      description:
        "Access holder-only campaigns, premium giveaways, priority rewards, and higher winning chances during major ecosystem events.",
    },
    {
      id: 3,
      title: "Stake CVMech to Earn $CVAI",
      description:
        "Stake your CVMech NFT to share a $1,000 total reward pool distributed among holders during the program period, with additional incentives for top holders.",
    },
    {
      id: 4,
      title: "Tier 4 IDO Access (Highest Tier)",
      description:
        "Automatic Tier 4 access on CVPad, including 100 percent refund protection within 24 hours, guaranteed private deals, higher allocations, and priority access to early rounds.",
    },
    {
      id: 5,
      title: "VIP Events & IRL Meetups",
      description:
        "Invitation to private online sessions, exclusive networking events, and real-life meetups with founders, builders, investors, and partners.",
    },
    {
      id: 6,
      title: "Exclusive Merch & Physical Rewards",
      description:
        "Receive limited-edition merchandise such as apparel, collectibles, and themed items tied to major ecosystem milestones.",
    },
    {
      id: 7,
      title: "Mystery Box Airdrops",
      description:
        "Access special mystery box airdrops with guaranteed rewards, adding surprise and long-term value for holders.",
    },
  ];

  return (
    <div className="wrapper">
      <Preloader />
      <Menu />

      <section
        className="free-mint"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/bg-banner-freemint.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(7, 10, 41, 0.85)",
            zIndex: 0,
          }}
        />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Free Mint</span>
                </h6>
                <h3 className="heading" data-aos="fade-up">
                  CVMECH - The Free Mint We Are All Waiting For
                </h3>
                <p className="mb-30">
                  Mint your CVMech for free and become one of the early holders
                  shaping the future of CVPad from now!
                </p>
              </div>

              <div className="countdown-timer">
                <div className="countdown-item">
                  <div className="countdown-value">{timeLeft.days}</div>
                  <div className="countdown-label">Days</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-value">{timeLeft.hours}</div>
                  <div className="countdown-label">Hours</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-value">{timeLeft.minutes}</div>
                  <div className="countdown-label">Minutes</div>
                </div>
                <div className="countdown-separator">:</div>
                <div className="countdown-item">
                  <div className="countdown-value">{timeLeft.seconds}</div>
                  <div className="countdown-label">Seconds</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="nft-showcase"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/bg-banner.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(7, 10, 41, 0.85)",
            zIndex: 0,
          }}
        />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Collection Preview</span>
                </h6>
                <h3 className="heading" data-aos="fade-up">
                  CVMech Collection Preview
                </h3>
              </div>
            </div>
            {nftCollection.slice(0, 12).map((nft) => (
              <div key={nft.id} className="col-xl-3 col-md-6">
                <div className="nft-item" data-aos="fade-up">
                  <div className="card-media">
                    <img src={nft.image} alt={nft.title} />
                  </div>
                  <div className="card-title">
                    <span className="h5">{nft.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="benefits"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/bg-banner.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(7, 10, 41, 0.85)",
            zIndex: 0,
          }}
        />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Benefits</span>
                </h6>
                <h3 className="heading" data-aos="fade-up">
                  Exclusive Benefits for
                  <br />
                  CVMech Holders
                </h3>
              </div>
            </div>

            {benefits.map((benefit, index) => (
              <div key={benefit.id} className="col-xl-4 col-md-6">
                <div
                  className="benefit-box"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="benefit-number">{benefit.id}</div>
                  <h5 className="benefit-title">{benefit.title}</h5>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </div>
  );
};

export default FreeMint;
